import { VesselCreateRequestMessage } from '../../../types/VesselCreateRequestMessage';
import { VesselMessage } from '../../../types/VesselMessage';
import { useDrawer } from '../../cdl/Drawer/useDrawer.hook';
import { useToasts } from '../../cdl/Toast/useToasts';
import { CreateVesselForm } from '../../vessel/CreateVessel/CreateVesselForm';
import { translate } from '../helpers/translate.helper';

import { useVesselCreate } from './useVesselCreate';

interface VesselCreateModalProps {
    onSuccess?: (vessel: VesselMessage) => void;
    onCancel?: () => void;
}

export const useVesselCreateModal = ({ onCancel, onSuccess }: VesselCreateModalProps = {}) => {
    const { push, hasLayers, pop } = useDrawer();
    const { addToast, addErrorToast } = useToasts();
    const vesselCreateMutation = useVesselCreate();

    return {
        isOpen: hasLayers,
        open: () => {
            const handleSubmit = async (vessel: VesselCreateRequestMessage) => {
                try {
                    const createdVessel = await vesselCreateMutation.mutateAsync({ vessel });

                    onSuccess?.(createdVessel);
                    pop(drawerId);
                    addToast(translate('createVesselForm.toast.success'));
                } catch {
                    addErrorToast(translate('createVesselForm.toast.error'));
                }
            };

            const drawerId = push({
                header: { title: translate('createVesselForm.title') },
                onPop: () => {
                    onCancel?.();
                },
                content: <CreateVesselForm onSubmit={handleSubmit} />,
            });
        },
    };
};
